import { useQueryClient } from '@tanstack/react-query';

import { dbaKeys } from './query-keys';

export function useInvalidateDba(): () => Promise<void> {
  const queryClient = useQueryClient();
  return async () => {
    await Promise.all([
      queryClient.invalidateQueries({ queryKey: dbaKeys.accountAll }),
      queryClient.invalidateQueries({ queryKey: dbaKeys.accountsAll }),
      queryClient.invalidateQueries({ queryKey: dbaKeys.discounts }),
      queryClient.invalidateQueries({ queryKey: dbaKeys.actionsAll }),
    ]);
  };
}
